module.exports = __webpack_public_path__ + "static/sendgrid-538648598314d6ff7dec4ae7be1aa1a3.png";